(function(_){
    'use strict';
    _['RESTAURANT.KEY']='Página';
    _['RESTAURANT.CATEGORIES'] = 'Categorias';
    _['RESTAURANT.NO-CONTENT'] = 'Não há conteúdo neste módulo';
    _['RESTAURANT.NO-CONTENT-FOODS'] = 'Não há conteúdo nesta categoria';
    _['RESTAURANT.FROM'] = 'Desde';
    _['RESTAURANT.ADD'] = 'Adicionar';
    _['RESTAURANT.VIEW_DETAIL'] = 'Ver detalhes';
    _['RESTAURANT.GO-BACK-RESTAURANT'] ='Volta a categorias';
    _['RESTAURANT.GO-BACK-CATEGORY'] ='Voltar à categoria';
    _['RESTAURANT.PRICE'] ='Preço';
    _['RESTAURANT.EXPAND'] ='Ver descrição';
    _['RESTAURANT.COLLAPSE'] ='Ocultar';

}(translations['pt']));












// WEBPACK FOOTER //
// ./src/app/modules/restaurant/lang/restaurant-lang_pt.js